import { concatMap, map } from "rxjs";
import { generateSecureToken } from "../../utils";
import { apiService } from "../ApiService";
import { UserToken } from "../../model";

export const lgCreateAccount = (sessionID: string) => {
  return generateSecureToken(apiService.userAgent)
    .pipe(
      concatMap((secureToken) =>
        apiService.post<UserToken>({
          path: `v1/store/lg/account`,
          body: {
            sessionID,
          },
          secureToken,
        }),
      ),
    )
    .pipe(
      map((token) => {
        apiService.userToken = token.userToken;
        apiService.familyToken = token.familyToken;
        return token;
      }),
    );
};
